import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { useMedicalHistory } from "features/patients/hooks/useMedicalHistory";

import styles from "../../PatientOverviewModal.module.css";
import { Table } from "./Table/Table";

export const MedicalHistory = ({
  patientId: patientIdProp,
  detailsColumnWidth,
  dateRecorderColumnWidth,
}) => {
  // Defaults to the route's patient (the usual case, e.g. the Details tab), but
  // accepts an explicit id for contexts with no patient route param — the Home
  // page's "selected" patient comes from the schedule, not the URL.
  const currentPatientId = useCurrentPatientId();
  const patientId = patientIdProp ?? currentPatientId;

  const {
    data: medicalHistory,
    isLoading,
    isError,
    refetch,
  } = useMedicalHistory(patientId);

  return (
    <div className={styles.medicalHistoryWrapper}>
      <Table
        items={(medicalHistory || []).map((item) => ({
          id: item.id,
          dateRecorded: item.recordedDate,
          idc: `${item.diseaseCode || ""} ${item.medicalDetails}`,
        }))}
        isLoading={isLoading}
        isError={isError}
        onRetry={refetch}
        detailsColumnWidth={detailsColumnWidth}
        dateRecorderColumnWidth={dateRecorderColumnWidth}
      />
    </div>
  );
};
